import { Injectable, inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn
} from '@angular/router';
import { Role } from '../enum/role';
import { AuthenticationService } from '../services/authentication.service';
import { IdentityService } from '../services/identity.service';

@Injectable({ providedIn: 'root' })
class PermissionsService {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private identityService: IdentityService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    let role = null;
    let clientId = null;
    if (!this.authenticationService.isJwtExpired()) {
      role = this.authenticationService.getRole();
      clientId = this.authenticationService.getClientId();
    }

    if (
      this.authenticationService.getJwt() === '' &&
      route.data['roles'] !== Role.None
    ) {
      await this.identityService.logout();
      this.router.navigate(['/login']);
      return false;
    } else if (
      this.authenticationService.getJwt() === '' &&
      route.data['roles'] === Role.None
    ) {
      return true;
    }

    if (clientId) {
      if (route.data['roles'] === Role.None) {
        this.router.navigate(['/dashboard']);
        return true;
      }
      if (route.data['clientId'] && route.data['clientId'].indexOf(clientId) === -1) {
        this.router.navigate(['/']);
        return false;
      }
      return true;
    }
    if (route.routeConfig.path === '') {
      return true;
    }

    await this.identityService.logout();
    return false;
  }
}
export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  return inject(PermissionsService).canActivate(next, state);
};
